import React from 'react'
import AppLayout from '../../../layout/components/AppLayout'
import { NavLink } from 'react-router-dom'

function ClientLayout({children}) {
  return (
    <AppLayout>
        <div className='container-fluid'>        
            <div className='row'>
                <div className='col-md-3'>
                    <div className='list-group'>
                        <NavLink to={"/client/dashboard"} className="list-group-item list-group-item-action">Dashboard</NavLink>
                        <NavLink to={"/client/search"} className="list-group-item list-group-item-action">Search</NavLink>
                        <NavLink to={"/client/list"} className="list-group-item list-group-item-action">List</NavLink>
                    </div>
                </div>
                <div className='col-md-9'>
                    {children}
                </div>
            </div>
        </div>
            
    </AppLayout>
    )
}

export default ClientLayout